import { giphyUrl, publicRuntimeConfig } from '@/app/util/env'
import { appendParams, getCookie } from '@/util/url'
import { GifResult, GifsResult } from '@giphy/js-fetch-api'
import { timeoutFetch } from 'utils/src/api/fetch'

function getUrl(path: string, accessToken: string) {
    const p = `${publicRuntimeConfig.apiUrl}${path}`
    let url
    try {
        url = new URL(p)
    } catch (error) {
        console.error('Invalid URL:', p)
        throw error
    }
    return appendParams(url, {
        api_key: publicRuntimeConfig.apiKey,
        access_token: accessToken,
    })
}

export const derankUser = async (
    channelId: number,
    accountType: string,
    level: string,
    magicTags: any,
    accessToken: string,
    cookie: string
) => {
    const f = await timeoutFetch({
        url: `${giphyUrl}/api/v4/channels/derank`,
        options: {
            cookie,
            method: 'POST',
            headers: {
                Authorization: `Token ${accessToken}`,
                'Content-Type': 'application/json',
                'X-CSRFToken': getCookie('csrftoken', cookie),
            },
            body: JSON.stringify({
                channel_id: channelId,
                account_type: accountType,
                level: level,
                magic_tags: magicTags,
            }),
        },
    })
    return (await f.json()) as GifResult
}
